import Actions from "../action";

const initialState = {
    isLoading: false,
    supervisorList: [],
    totalCount: 0,
    suggestions: [],
    error: false,
};

const AccessControlReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case Actions.ACCESS_CONTROL_SUPERVISORS: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case Actions.ACCESS_CONTROL_SUPERVISORS_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                supervisorList: action.data?.results || [],
                totalCount: action.data?.count ?? 0,
                error: false,
            };
        }
        case Actions.ACCESS_CONTROL_SUPERVISORS_FAILURE: {
            return {
                ...state,
                isLoading: false,
                supervisorList: [],
                totalCount: 0,
                error: action.error,
            };
        }
        case Actions.ACCESS_CONTROL_ADD_HOSTEL:
        case Actions.ACCESS_CONTROL_REMOVE_HOSTEL: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case Actions.ACCESS_CONTROL_ADD_HOSTEL_SUCCESS:
        case Actions.ACCESS_CONTROL_REMOVE_HOSTEL_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                error: false,
            };
        }
        case Actions.ACCESS_CONTROL_ADD_HOSTEL_FAILURE:
        case Actions.ACCESS_CONTROL_REMOVE_HOSTEL_FAILURE: {
            return {
                ...state,
                isLoading: false,
                error: action.error,
            };
        }
        case Actions.ACCESS_CONTROL_SUGGESTIONS_SUCCESS: {
            return {
                ...state,
                suggestions: action.data?.results || [],
            };
        }
        case Actions.ACCESS_CONTROL_SUGGESTIONS_CLEAR: {
            return {
                ...state,
                suggestions: [],
            };
        }
        default:
            return state;
    }
};

export default AccessControlReducer;
export const getAccessControlSupervisorListSelector = (state) =>
    state?.ACCESS_CONTROL?.supervisorList || [];
export const getAccessControlTotalCountSelector = (state) =>
    state?.ACCESS_CONTROL?.totalCount ?? 0;
export const getAccessControlSuggestionsSelector = (state) =>
    state?.ACCESS_CONTROL?.suggestions || [];
export const getAccessControlLoadingSelector = (state) =>
    state?.ACCESS_CONTROL?.isLoading || false;
